import { render, staticRenderFns } from "./PanoramicLive.vue?vue&type=template&id=1b7c1152&scoped=true"
import script from "./PanoramicLive.vue?vue&type=script&lang=js"
export * from "./PanoramicLive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7c1152",
  null
  
)

export default component.exports